import * as React from 'react';
import Tenor from '../../../../../models/data/Tenor';
import PeriodEditor from './coupons/PeriodEditor';
import PopupButtons from './PopupButtons';
import { numberRegex } from 'utils/validation';
const TenorPopup = ({ data, hasOverride, save }) => {
    const [value, setValue] = React.useState(data?.override?.maturity?.tenor?.value ?? data?.data?.maturity?.tenor?.value);
    const [nonCall, setNonCall] = React.useState(data?.override?.maturity?.tenor?.nonCall ?? data?.data?.maturity?.tenor?.nonCall);
    const options = React.useMemo(() => {
    }, []);
    const onChangeValue = React.useCallback((event) => {
        setValue(event.target.value);
    }, []);
    const onChangeNonCall = React.useCallback((event) => {
        setNonCall(event.target.value);
    }, []);
    const tenor = React.useMemo(() => {
        if (value === undefined) {
            return undefined;
        }
        return new Tenor({ value, nonCall });
    }, [nonCall, value]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { display: 'flex', width: '13rem' } },
            React.createElement("div", { style: { marginRight: '1.25rem' } },
                React.createElement(PeriodEditor, { defaultPeriod: 'Y', label: "Tenor", regex: numberRegex, style: {}, value: value, onChange: onChangeValue })),
            React.createElement(PeriodEditor, { defaultPeriod: 'Y', label: "Non Call", regex: numberRegex, style: {}, value: nonCall, onChange: onChangeNonCall })),
        React.createElement("div", { style: { display: 'flex', justifyContent: 'right', marginTop: '0.5rem' } },
            React.createElement(PopupButtons, { hasOverride: hasOverride, isDisabled: false, save: save, value: tenor }))));
};
export default TenorPopup;
